import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  doneHere: {
    defaultMessage: "You're done. You can now close this tab.",
    id: 'FlowFinished.done',
  },
});
